import { createContext, useContext } from 'react';

/**
 * A surface context provides context information on the current background (if set).
 */
const SurfaceContext = /*#__PURE__*/createContext({
  isInverted: false
});

/**
 * Return the current surface. If no parent sets a surface color it falls back to the default surface.
 */
const useSurface = () => useContext(SurfaceContext);
SurfaceContext.displayName = 'SurfaceProvider';

export { SurfaceContext as S, useSurface as u };
//# sourceMappingURL=SurfaceProvider-qDGZSFCj.js.map
